export class Search {
    constructor() {
        this.searchInput = document.getElementById('search-input');
        this.searchClear = document.getElementById('search-clear');
        this.searchSubmit = document.getElementById('search-submit');
        this.searchResults = document.getElementById('search-results');
        this.searchResultsList = document.getElementById('search-results-list');
        this.searchClose = document.getElementById('search-close');
        this.searchShowAll = document.getElementById('search-show-all');
        
        // Мобильные элементы
        this.mobileSearchInput = document.getElementById('mobile-search-input');
        this.mobileSearchResults = document.getElementById('mobile-search-results');
        this.mobileSearchResultsList = document.getElementById('mobile-search-results-list');
        this.mobileSearchClear = document.getElementById('mobile-search-clear');
        this.mobileSearchShowAll = document.getElementById('mobile-search-show-all');
        
        this.isVisible = false;
        this.searchTimeout = null;
        this.currentQuery = '';
        this.isLoading = false;
        
        this.init();
    }
    
    init() {
        // Инициализация десктопного поиска
        if (this.searchInput) {
            this.initDesktopSearch();
        }
        
        // Инициализация мобильного поиска
        if (this.mobileSearchInput) {
            this.initMobileSearch();
        }
    }
    
    initDesktopSearch() {
        // Обработчики событий для десктопа
        this.searchInput.addEventListener('input', (e) => {
            this.handleInput(e.target.value, 'desktop');
        });
        
        this.searchInput.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                this.performSearch('desktop');
            } else if (e.key === 'Escape') {
                this.hideResults('desktop');
            }
        });
        
        this.searchClear.addEventListener('click', () => {
            this.clearSearch('desktop');
        });
        
        this.searchSubmit.addEventListener('click', () => {
            this.performSearch('desktop');
        });
        
        this.searchClose.addEventListener('click', () => {
            this.hideResults('desktop');
        });
        
        this.searchShowAll.addEventListener('click', () => {
            this.showAllResults('desktop');
        });
        
        // Клик вне поиска
        document.addEventListener('click', (e) => {
            if (!e.target.closest('.search-block')) {
                this.hideResults('desktop');
            }
        });
    }
    
    initMobileSearch() {
        // Обработчики событий для мобильного
        this.mobileSearchInput.addEventListener('input', (e) => {
            this.handleInput(e.target.value, 'mobile');
        });
        
        this.mobileSearchInput.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                this.performSearch('mobile');
            } else if (e.key === 'Escape') {
                this.hideResults('mobile');
            }
        });
        
        this.mobileSearchClear.addEventListener('click', () => {
            this.clearSearch('mobile');
        });
        
        this.mobileSearchShowAll.addEventListener('click', () => {
            this.showAllResults('mobile');
        });
        
        // Клик вне мобильного поиска
        document.addEventListener('click', (e) => {
            if (!e.target.closest('.mobile-search-block')) {
                this.hideResults('mobile');
            }
        });
    }
    
    handleInput(value, type = 'desktop') {
        this.currentQuery = value.trim();
        
        const searchClear = type === 'mobile' ? this.mobileSearchClear : this.searchClear;
        
        // Показываем/скрываем кнопку очистки
        if (this.currentQuery.length > 0) {
            if (searchClear) searchClear.style.display = 'flex';
        } else {
            if (searchClear) searchClear.style.display = 'none';
            this.hideResults(type);
        }
        
        // Очищаем предыдущий таймер
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }
        
        // Запускаем поиск с задержкой
        if (this.currentQuery.length >= 2) {
            this.searchTimeout = setTimeout(() => {
                this.searchAjax(this.currentQuery, type);
            }, 300);
        } else {
            this.hideResults(type);
        }
    }
    
    async searchAjax(query, type = 'desktop') {
        if (query.length < 2) return;
        
        this.isLoading = true;
        this.showLoadingResults(type);
        
        try {
            // Используем систему поиска
            const response = await fetch(`/search.php?q=${encodeURIComponent(query)}&limit=10`);
            const data = await response.json();
            
            this.isLoading = false;
            
            if (data.results && data.results.length > 0) {
                this.displayResults(data.results, query, type);
            } else {
                this.showEmptyResults(type);
            }
        } catch (error) {
            console.error('Ошибка поиска:', error);
            this.isLoading = false;
            this.showEmptyResults(type);
        }
    }
    
    displayResults(results, query, type = 'desktop') {
        if (results.length === 0) {
            this.showEmptyResults(type);
            return;
        }
        
        const resultsList = type === 'mobile' ? this.mobileSearchResultsList : this.searchResultsList;
        resultsList.innerHTML = '';
        
        results.forEach(result => {
            const li = document.createElement('li');
            li.className = 'search-results-item';
            li.innerHTML = `
                <div class="search-results-item-title">${this.highlightText(result.title, query)}</div>
                <div class="search-results-item-description">${this.highlightText(result.description, query)}</div>
                <div class="search-results-item-url">${result.url}</div>
            `;
            
            li.addEventListener('click', () => {
                window.location.href = result.url;
            });
            
            resultsList.appendChild(li);
        });
        
        this.showResults(type);
    }
    
    highlightText(text, query) {
        if (!query) return text;
        
        const regex = new RegExp(`(${query})`, 'gi');
        return text.replace(regex, '<mark>$1</mark>');
    }
    
    hideResults(type = 'desktop') {
        const searchResults = type === 'mobile' ? this.mobileSearchResults : this.searchResults;
        if (searchResults) {
            searchResults.style.display = 'none';
        }
        this.isVisible = false;
    }
    
    showResults(type = 'desktop') {
        const searchResults = type === 'mobile' ? this.mobileSearchResults : this.searchResults;
        if (searchResults) {
            searchResults.style.display = 'block';
        }
        this.isVisible = true;
    }
    
    showEmptyResults(type = 'desktop') {
        const resultsList = type === 'mobile' ? this.mobileSearchResultsList : this.searchResultsList;
        if (resultsList) {
            resultsList.innerHTML = '<li class="search-results-empty">Ничего не найдено</li>';
        }
        this.showResults(type);
    }
    
    showLoadingResults(type = 'desktop') {
        const resultsList = type === 'mobile' ? this.mobileSearchResultsList : this.searchResultsList;
        if (resultsList) {
            resultsList.innerHTML = '<li class="search-results-loading">Поиск...</li>';
        }
        this.showResults(type);
    }
    
    clearSearch(type = 'desktop') {
        const searchInput = type === 'mobile' ? this.mobileSearchInput : this.searchInput;
        const searchClear = type === 'mobile' ? this.mobileSearchClear : this.searchClear;
        
        if (searchInput) {
            searchInput.value = '';
            searchInput.focus();
        }
        
        this.currentQuery = '';
        
        if (searchClear) {
            searchClear.style.display = 'none';
        }
        
        this.hideResults(type);
    }
    
    performSearch(type = 'desktop') {
        if (this.currentQuery.length < 2) return;
        
        // Здесь можно добавить переход на страницу поиска
        // window.location.href = `/search?q=${encodeURIComponent(this.currentQuery)}`;
        
        // Или показать все результаты
        this.showAllResults(type);
    }
    
    async showAllResults(type = 'desktop') {
        if (this.currentQuery.length < 2) return;
        
        this.isLoading = true;
        this.showLoadingResults(type);
        
        try {
            const response = await fetch(`/search.php?q=${encodeURIComponent(this.currentQuery)}&limit=20`);
            const data = await response.json();
            
            this.isLoading = false;
            
            if (data.results && data.results.length > 0) {
                this.displayResults(data.results, this.currentQuery, type);
            } else {
                this.showEmptyResults(type);
            }
        } catch (error) {
            console.error('Ошибка поиска:', error);
            this.isLoading = false;
            this.showEmptyResults(type);
        }
    }
}
